module.exports = "/_next/static/images/ad391cfafd5652979a5d91449fb26891-people-smile-at-home-xs@1x.jpg";